(function cf7_init($) {
    $( '.field-overlay:not(.active)' ).click( function( e ) {
        // e.preventDefault();
        if ($(this).parent().find('input').length) {
            $(this).parent().find('input').focus();
        } else if ($(this).parent().find('textarea').length) {
            $(this).parent().find('textarea').focus();
        }
    });

    $('.form-field-group input, .form-field-group textarea').on('focus', function (e) {
        $(this).parent().parent().find('.field-overlay').addClass('active');
    });


    $('.form-field-group input, .form-field-group textarea').on('blur', function (e) {
        if ($(this).val() === '') {
            $(this).parent().parent().find('.field-overlay').removeClass('active');
        }
    });
})(jQuery);


